import { FC } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'
import InputWithButton from '@/components/common/input-with-button'

export interface WarrantyQueryFormProps {
  onSubmit: (snOrMac: string) => void
  isLoading?: boolean
  error?: string | null
}

const warrantyQuerySchema = Yup.object().shape({
  snOrMac: Yup.string()
    .required('Please input SN/MAC')
    .test('valid-sn-mac', 'Invalid SN/MAC format', (value) => {
      if (!value) {
        return false
      }
      const snRegex = /^[0-9a-zA-Z]{13,16}$/
      const macRegex = /^[a-fA-F0-9:]{17}$/
      return snRegex.test(value.trim()) || macRegex.test(value.trim())
    }),
})

const WarrantyQueryForm: FC<WarrantyQueryFormProps> = ({
  onSubmit,
  isLoading = false,
  error,
}) => {
  const t = useTranslations()
  type FormData = {
    snOrMac: string
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(warrantyQuerySchema) as any,
  })

  const onFormSubmit = (data: FormData) => {
    onSubmit(data.snOrMac)
  }

  return (
    <div className={clsx('w-full')}>
      {/* 使用一套结构，通过响应式类名区分 PC 和 H5 */}
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className={clsx(
          'w-full',
          'bg-transparent laptop:bg-white/90 laptop:backdrop-blur-[48px]',
          'rounded-none laptop:rounded-lg',
          'p-0',
          'flex flex-col',
          'gap-6 laptop:gap-4',
          'laptop:min-h-[110px]'
        )}
      >
        <p
          className={clsx(
            'w-full',
            'text-14 laptop:text-14',
            'font-semibold',
            'text-black/60',
            'leading-[21px] laptop:leading-[22px]'
          )}
        >
          {t('FaultReportingForm.QueryDesc')}
        </p>

        <InputWithButton
          inputProps={register('snOrMac')}
          placeholder={t('FaultReportingForm.EnterSNOrMAC')}
          inputType="text"
          inputDisabled={isLoading}
          buttonText={t('FaultReportingForm.Confirm')}
          buttonDisabled={isLoading}
          isLoading={isLoading}
          loadingText={t('FaultReportingForm.Querying')}
          inputWidthPC="w-[299px]"
          buttonWidthPC="w-[102px]"
          buttonWidthH5="w-[100px]"
          errorClassName="leading-[21px] laptop:leading-6"
          error={
            (errors.snOrMac?.message && t('FaultReportingForm.InvalidSNOrMAC')) ||
            error ||
            null
          }
        />
      </form>
    </div>
  )
}

export default WarrantyQueryForm
